import React from 'react';
import Box from '@material-ui/core/Box';
import PanelSection from '../../../shared/layout/PanelSection';
import LabelValue from '../../../shared/label-value/LabelValue';
import { IInputFieldProps, IProfileGridItemProps } from '../../../../types';
import ChipInfo from '../../../shared/chip-info';

export const ProfileGridItem = (props: IProfileGridItemProps) => {
  const { title, labelValues, classes, children, infoText } = props;

  return (
    <PanelSection title={title}>
      {labelValues.map(
        (
          {
            label,
            value,
            checked,
            actionLabel,
            actionHandler,
            actionToggle,
            onToggle,
            className,
            hasDivider,
          }: IInputFieldProps,
          index: string,
        ) => {
          return (
            <LabelValue
              key={index.toString()}
              className={classes.labelValueMargins}
              label={label}
              actionLabel={actionLabel}
              actionHandler={actionHandler}
              actionToggle={actionToggle}
              onToggle={onToggle}
              checked={checked}
              hasDivider={hasDivider}
              value={
                <Box fontWeight="bold">
                  <div className={className}>{value}</div>
                </Box>
              }
            />
          );
        },
      )}
      {children}
      {infoText && (
        <Box className={classes.chipWrapper}>
          <ChipInfo type="info" text={infoText} />
        </Box>
      )}
    </PanelSection>
  );
};

ProfileGridItem.defaultProps = {
  children: null,
};
